<template>
  <b-container>
    <div>
      <h1>{{ $t("checklist.form.userChange") }}</h1>
      <success-fade-alert
        ref="alert"
        :msg="this.$t('checklist.form.userChangeSuccess')"
      />
      <fade-alert-danger ref="error" :msg="alert.error" />
    </div>
    <b-row>
      <b-col md="none">
        <router-link to="/checklist/Layout/form/Draft/">
          <b-button size="sm">{{ $t("geral.backtolist") }}</b-button>
        </router-link>
      </b-col>
    </b-row>

    <b-row>
      <b-col lg="8" md="8" sm="12">
        <b-form-group
          label="Formulario"
          label-for="input-formName"
          label-cols-sm="5"
          label-cols-md="5"
          label-cols-lg="5"
        >
          <b-form-input
            type="text"
            id="input-formName"
            v-model="checklist.formName"
            readonly
          />
        </b-form-group>
        <b-form-group
          :label="$t('checklist.form.searchKey')"
          label-for="input-searchKey"
          label-cols-sm="5"
          label-cols-md="5"
          label-cols-lg="5"
        >
          <b-form-input
            type="text"
            id="input-searchKey"
            v-model="checklist.formSearchKey"
            readonly
          />
        </b-form-group>
        <b-form-group
          label="Data preenchimento"
          label-for="input-dateFill"
          label-cols-sm="5"
          label-cols-md="5"
          label-cols-lg="5"
        >
          <b-form-input
            type="text"
            id="input-dateFill"
            v-model="formatedDateFill"
            readonly
          />
        </b-form-group>
        <b-form-group
          label="Responsável atual"
          label-for="input-userFillName"
          label-cols-sm="5"
          label-cols-md="5"
          label-cols-lg="5"
        >
          <b-form-input
            type="text"
            id="input-userFillName"
            v-model="checklist.userFillName"
            readonly
          />
        </b-form-group>
        <b-form-group
          label="Novo responsável"
          label-for="UserId"
          label-cols-sm="5"
          label-cols-md="5"
          label-cols-lg="5"
        >
          <b-form-select
            id="UserId"
            v-model="checklistUserChange.newUserId"
            required
            :options="optionsUsers"
          />
          <span class="text-danger" v-if="modelstate['NewUserId']">
            {{ modelstate["NewUserId"][0] }}
          </span>
          <span class="text-danger" v-if="modelstate['$.newUserId']">
            {{ modelstate["$.newUserId"][0] }}
          </span>
          <span class="text-danger" v-if="modelstate['$.checklistId']">
            {{ modelstate["$.checklistId"][0] }}
          </span>
        </b-form-group>
      </b-col>
    </b-row>

    <b-button variant="primary" :disabled="submitted" @click="save">
      Salvar
    </b-button>
    
    <!-- <pre class="language-json"><code>checklist: {{ checklist  }}</code></pre> -->
    <!-- <pre class="language-json"><code>checklistUserChange: {{ checklistUserChange  }}</code></pre> -->
    <!-- <pre class="language-json"><code>optionsUsers: {{ optionsUsers  }}</code></pre> -->
    <!-- <pre class="language-json"><code>modelstate: {{ modelstate  }}</code></pre> -->
  </b-container>
</template>

<script>
export default {
  name: "ChecklistUserChange",
  props: {
    checklistId: String,
  },
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
  },
  directives: {},
  data: function () {
    return {
      alert: {
        error: "",
      },
      checklist: {},
      checklistUserChange: {
        checklistId: null,
        currentUserId: null,
        newUserId: null,
      },
      companyId: 0,
      optionsUsers: [],
      modelstate: {},
      submitted: false,
    };
  },
  created: function () {
    if (this.checklistId) {
      this.loadData();
    }
  },
  computed: {
    formatedDateFill() {
      if (this.checklist) {
        let date = new Date(this.checklist.dateFill);
        return date.toLocaleString();
      }
      return "";
    },
  },
  methods: {
    async loadData() {
      this.$apiChecklist
        .get(`/v2/checklist/get/${this.checklistId}`)
        .then((response) => {
          let checklist = response.data;
          this.checklist = checklist;
          if (this.checklist) {
            this.checklistUserChange = {
              checklistId: parseInt(this.checklistId),
              currentUserId: this.checklist.userFillId,
              newUserId: null,
            };
            this.loadOptionsUsers();
          } else {
            this.checklistUserChange = {
              checklistId: null,
              currentUserId: null,
              newUserId: null,
            };
            this.loadOptionsUsers();
          }
        })
        .catch((error) => {
          this.checklist = {};
          this.checklistUserChange = {
            checklistId: null,
            currentUserId: null,
            newUserId: null,
          };
          this.loadOptionsUsers();
          console.log(error);
          console.log(error.response.data.errors);
          if (error.response.status == 400) {
            this.modelstate = error.response.data.errors;
          }
        });
    },
    async loadOptionsUsers() {
      console.log('loadOptionsUsers - begin');
      console.log(this.checklist);
      if (!this.checklist) {
         this.optionsUsers = [];
         return;
      }
      if (!this.checklist.formId)  {
         this.optionsUsers = [];
         return;
      }
      console.log('loadOptionsUsers - init');
      this.$apiChecklist
        .get(`/v1/form/permissions/users/dropdown/${this.checklist.formId}`)
        .then((response) => {
          this.optionsUsers = [{ value: null, text: "" }];
          response.data.forEach((x) => {
            this.optionsUsers.push({
              value: x.value,
              text: x.text,
            });
          });
        })
        .catch((error) => {
           this.optionsUsers = [];
        });
    },
    save() {
      this.submitted = true;
      this.$apiChecklist
        .post("/v1/checklist/user/change/", this.checklistUserChange)
        .then((response) => {
          this.$refs.alert.show();
          this.submitted = false;
          this.modelstate = {};
        })
        .catch((error) => {
          this.submitted = false;
          console.log(error);
          console.log(error.response);
          if (error.response.status == 400) {
            this.alert.error = error.response.data.title;
            this.$refs.error.show();
            this.modelstate = error.response.data.errors;
          } else if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }
        });
    },
  },
};
</script>
